import React, { useCallback, useMemo } from 'react';
import { useDisclosure } from '@televet/kibble-ui/build/chakra';
import { RouteBasePaths } from 'routes';
import { BlockedNavigationModal } from 'shared/components/BlockedNavigation';
import { useSaveAutomationDraft } from 'pages/Automations/hooks';
import { useAppDispatch, useAppSelector } from 'state/hooks';
import { AutomationEditorView } from 'pages/Automations/types/AutomationEditorView';
import { resetAutomationsState } from 'pages/Automations/state/automationsSlice';
import { useCurrentAutomationId } from 'pages/Automations/hooks/useCurrentAutomationId';
import { useGetAutomationsBasePath } from 'pages/Automations/hooks/useGetAutomationsBasePath';

export const UnsavedAutomationChangesModal = (): JSX.Element => {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const shouldBlockNavigation = useAppSelector((state) => state.automations.shouldBlockNavigation);
  const { hasUnsavedChanges } = useSaveAutomationDraft();
  const currentAutomationId = useCurrentAutomationId();
  const dispatch = useAppDispatch();
  const { automationsBasePath } = useGetAutomationsBasePath();

  const allowedUrls = useMemo(() => {
    return [
      `${RouteBasePaths.Automations}/${currentAutomationId}/${AutomationEditorView.Compose}`,
      `${RouteBasePaths.Automations}/${currentAutomationId}/${AutomationEditorView.Settings}`,
      `${RouteBasePaths.GlobalAutomations}/${currentAutomationId}/${AutomationEditorView.Compose}`,
      `${RouteBasePaths.GlobalAutomations}/${currentAutomationId}/${AutomationEditorView.Settings}`,
      ...(!currentAutomationId ? [automationsBasePath] : []),
    ];
  }, [currentAutomationId, automationsBasePath]);

  const handleContinue = useCallback(() => {
    onClose();
    dispatch(resetAutomationsState());
  }, [onClose, dispatch]);

  return (
    <BlockedNavigationModal
      shouldBlockNavigation={hasUnsavedChanges && shouldBlockNavigation}
      allowedUrls={allowedUrls}
      isOpen={isOpen}
      onCancel={onClose}
      onContinue={handleContinue}
      onOpen={onOpen}
    />
  );
};
